var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{attrs:{"default-active":_vm.active,"collapse":_vm.isCollapse,"router":true,"mode":_vm.mode,"default-openeds":_vm.defaultOpeneds},on:{"open":_vm.handleOpen,"close":_vm.handleClose,"select":_vm.select}},[_vm._l((_vm.routerList),function(router,idx){return [_c('sub-menu',{key:idx,attrs:{"index":router.path,"router":router}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }